import { AppOriginType } from '@bamse-digital/marisa-servicos';
import { Platform } from 'react-native';

const getOriginType = (originParam: string | null) => {
  switch (originParam) {
    case 'totem':
      return AppOriginType.TOTEM;
    case 'site':
      return AppOriginType.SITE;
    case 'crediario':
      return AppOriginType.CREDIT;
    default:
      return AppOriginType.CREDIT;
  }
};

export const getQueryParams = () => {
  let authToken: string | undefined;
  let origin: AppOriginType = AppOriginType.CREDIT;
  if (Platform.OS === 'web') {
    const { window } = global;
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');
    const origem = urlParams.get('origem');
    if (token) {
      authToken = token;
      // urlParams.delete('token');
      // window.history.replaceState(
      //   {},
      //   window.document.title,
      //   `${window.location.pathname}?${urlParams.toString()}`
      // );
    }
    if (origem) {
      origin = getOriginType(origem);
    } else if (window.sessionStorage.getItem('origem')) {
      origin = getOriginType(window.sessionStorage.getItem('origem'));
    }
    window.sessionStorage.setItem('origem', origin);
  } else {
    origin = AppOriginType.APP;
  }
  return {
    authToken,
    origin,
  };
};
